export type AppRoute = 'index' | 'system-check' | 'system-check-report' | 'room' | 'no-match';

const SHARE_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;
const REPORT_SEGMENT_COUNT = 3;

const pathSegments = (pathname: string) => pathname.split('/').filter(Boolean);

export const shareIdFromPath = (pathname: string): string | null => {
  const [root, section, shareId, ...rest] = pathSegments(pathname);
  const isReportPath = root === 'system-check' && section === 'report' && rest.length === 0;

  return isReportPath && shareId !== undefined && SHARE_ID_PATTERN.test(shareId) ? shareId : null;
};

export const resolveRoute = (pathname: string): AppRoute => {
  const segments = pathSegments(pathname);

  if (segments.length === 0) {
    return 'index';
  }

  if (segments.length === 1) {
    return segments[0] === 'system-check' ? 'system-check' : 'room';
  }

  if (segments.length === REPORT_SEGMENT_COUNT && shareIdFromPath(pathname) !== null) {
    return 'system-check-report';
  }

  return 'no-match';
};
